<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>

      <div class="clause">
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          浦银快贷(发票贷)个人授信合同
        </p>
        <p class="distance_50" style="font-weight: bold;">
          授 信 人:上海浦东发展银行股份有限公司 住所地及联系电话:
        </p>
        <p class="distance_50" style="font-weight: bold;">
          受 信 人:
        </p>
        <p class="distance_50" style="font-weight: bold;">
          身份证件类型及编号:
        </p>
        <p class="distance_50" style="font-weight: bold;">
          住所地及联系电话:
        </p>
        <p class="distance_50" style="font-weight: bold;">
          鉴于:
        </p>
        <p class="distance_50">
          受信人向授信人申请或通过上海浦东发展银行股份有限公司(详见本合同第 14.1
          条的
          约定)向贷款人申请人民币个人授信额度，现根据中华人民共和国有关法律、法规，经当事
          人各方协商一致，特订立本合同，以资遵守。
        </p>
        <p style=" font-weight: bold; font-size: 12px;text-align:center">
          第一条 定义与解释
        </p>
        <p class="distance_50">
          除非本合同文义要求另作解释，本合同中的下列术语含义为:
        </p>
        <p class="distance_50">
          1.1
          授信:指授信人以提供授信额度的方式向拟以授信方式申请资金/信用融通的受信人提供资金/信用融通的操作方式。
        </p>
        <p class="distance_50">
          1.2
          授信额度、额度:在本合同中均指授信人根据本合同核定的、受信人可在本合同约定的
          授信额度有效期内向授信人申请支用的授信最高限额。
        </p>
        <p class="distance_50">
          1.3
          授信额度有效期，即授信有效期，是指受信人可在授信额度最高限额内支用授信额度的
          有效期限。
        </p>
        <p class="distance_50">
          1.4
          支用:指受信人在获得授信人授予的个人授信额度后，在该授信额度限额及授信额度有
          效期内向授信人申请使用额度的行为。根据授信人的有关规定及授信人与受信人之间的
          相关约定，该额度可适用于受信人申请的个人经营性贷款。支用首先应由受信人在线提
          交支用申请，授信人内部批准后，确认同意借款人另行在线签署借款合同。双方之间的
        </p>
        <p class="distance">
          具体权利义务以最终在线签署的借款合同约定为准。
        </p>
        <p class="distance_50">
          1.5
          业务文件：指受信人在支用授信额度的申请被批准后，与授信人在线签署的借款合同等。
        </p>
        <p class="distance_50">
          1.5
          通知：本合同中约定的通知，以电报、传真方式送达的，一经发出即视为已送达，以邮
          寄方式送达的，应以安全的形式发出，在邮件加盖邮递或承运章后三日，即视为已送达。
        </p>
        <p class="distance_50">
          1.6
          贷款本息：本合同在提及“贷款本息”时，意指包含贷款本金、利息、复利、逾期及挪
          用罚息以及与该贷款或贷款之担保相关的任何未清偿费用。
        </p>
        <p
          class="distance"
          style="color:#000;font-weight:bold; text-align:center"
        >
          第二条 授信额度的金额和期限
        </p>
        <p class="distance_50">
          2.1 本合同项下授信额度总额详见本合同第 14.2
          条的约定。在本合同约定的授信额度有效
          期内，受信人可向授信人请求支用的最高额度不得超过本合同约定的授信额度总额。
          若出现本合同第九条所列额度变更的情况，授信额度以变更后的额度为准。
        </p>
        <p class="distance_50">
          2.2 本合同项下的授信额度有效期详见本合同第 14.3
          条的约定。未在授信额度有效期内支
          用的授信额度，在授信额度有效期届满后自动取消。
        </p>
        <p class="distance_50">
          2.3
          除非双方在本合同中有明确的相反约定，受信人依据本合同取得的授信额度属于循环额
          度，即授信额度有效期内债务一旦清偿该部分额度自动恢复可循环支用。
        </p>
        <p
          class="distance"
          style="color:#000;font-weight:bold; text-align:center"
        >
          第三条 授信额度的支用申请
        </p>
        <p class="distance_50">
          3.1
          受信人可一次或分次向授信人申请支用本合同项下之授信额度，但应当事先在线提交支
          用申请。该申请应当载明所支用的金额、支用用途、支用期限、利率及浮动幅度、计划
          还款方式等要素。授信人对受信人的支用申请审查后，认为符合本合同约定的，予以办
          理。
        </p>
        <p class="distance_50">
          3.1
          授信人同意受信人提出的支用申请的，双方应当另行在线签署浦银快贷借款合同，具体
          权利义务最终以该浦银快贷个人借款合同约定为准。
        </p>
        <p class="distance_50">
          3.2
          在符合授信人有关规定的前提下，受信人可以支用该授信额度用于发放贷款、或划拨到
          受信人的银行卡内使用以及用于其他符合规定的用途。
        </p>
        <p class="distance_50">
          3.3 受信人支用授信额度的起点金额详见本合同第 14.4
          条的约定。低于起点金额的支用申 请，授信人可以拒绝接受。
        </p>
        <p class="distance_50">
          3.4
          受信人申请支用授信额度而向授信人申请发放贷款的，贷款的实际发放日为该贷款的起息日，且贷款的实际发放日不得超过授信额度有效期的到期日，但贷款到期日可以超过
          授信额度有效期的到期日。
        </p>
        <p class="distance_50">
          3.5
          受信人在授信额度有效期内依据本合同获得的每笔贷款，其贷款利率以浦银快贷个人借
          款合同的约定为准。
        </p>
        <p class="distance_50">
          3.6
          若受信人选择贷款发放后转存入非上海浦东发展银行个人账户的，由于贷款资金汇划过
          程中涉及多方清算系统，若发生部分贷款资金未到账的，授信人将对该部分资金进行提
          前还款，同时免除该部分资金产生的贷款利息。
        </p>
        <p class="distance_50">
          3.7
          受信人选择贷款发放后转存入非上海浦东发展银行个人账户的，即视作受信人委托授信
          人将贷款资金通过汇划方式转到约定账户，受信人对贷款资金因汇划在途耗时及其他非
          因授信人原因导致的无法即时到账无异议。
        </p>
        <p class="distance_50">
          3.8
          受信人选择贷款发放后转存入非人民银行规定的个人Ⅰ类账户的，应在贷款发放后
          20
          个自然日内，将转存账户升级为符合人民银行规定的个人Ⅰ类账户。逾期未完成升级的，
          授信人有权宣布贷款提前到期，受信人应立即清偿所有贷款本息。
        </p>
        <p
          class="distance"
          style="color:#000;font-weight:bold; text-align:center"
        >
          第四条 额度实际支用的先决条件
        </p>
        <p class="distance_50">
          4.1
          除非授信人同意，否则在以下条件在形式及内容方面均令授信人满意地全部达成前，授
          信人无任何义务向受信人提供依据本合同所确认同意浦银快贷个人借款合同项下贷款
          或其他信用额度：
        </p>
        <p class="distance_50">
          4.2
          保证合法使用大数金融提供的资讯或服务，遵守所有与大数金融服务有关的协议、规则和程序，清楚了解互联网产品，特别是个人消费贷款产品的使用方法和使用惯例，认可数据电文形式的合同效力。
        </p>
        <p class="distance_50">
          4.1.1
          受信人已有效签署本授信合同并已提供了经授信人认可的最高额担保措施，相
          关担保文件已确认同意，与前述文件有关的授权、财产共有人许可、登记及其
          他法定或必要的手续已办妥，且与本授信合同相对应的担保权（如有）已合法
          设立；
        </p>
        <p class="distance_50">
          4.1.2
          受信人在授信额度有效期内通过在线提交已向授信人提出符合要求的额度支
          用申请，且可用授信额度不低于支用申请金额，并已获得授信人批准；
        </p>
        <p class="distance_50">
          4.1.3
          受信人与授信人间已就被批准的额度支用事项在线签署浦银快贷个人借款合
          同，且受信人按照授信人要求对该浦银快贷个人借款合同提供了足够的担保措
          施，相关担保文件已确认同意，与前述文件有关的授权、财产共有人许可、登
          记及其他法定或必要的手续已办妥，且与浦银快贷个人借款合同相对应的担保
          权或类似优先权已合法设立（如有）；
        </p>
        <p class="distance_50">
          4.1.4
          上述担保方式应符合以下要求：采用抵押方式提供担保的，已办妥保险及抵押
          登记手续，并将该抵押财产登记凭证、权属凭证、抵押权凭证/他项权利凭证、
          保险单正本交由授信人保管；采用质押方式提供担保的，已将质押财产交由授
          信人保管；出质行为依法需要办理登记手续的，该登记已完成；采用保证方式
          担保的，保证合同已签订合法有效；
        </p>
        <p class="distance_50">
          4.1.5 受信人已按授信人要求开立用于提款、付息、付费及还款等的银行账户。
        </p>
        <p class="distance_50">
          4.1.6
          受信人在本合同以及浦银快贷个人借款合同中所作的保证与陈述是真实的，且
          受信人未发生可能对受信人的还款能力有不利影响的事件；担保人/担保财产
          未发生查封、扣押以及对受信人的还款能力有不利影响的事件；
        </p>
        <p class="distance_50">
          4.1.7
          未发生与本合同以及浦银快贷个人借款合同相关的法律法规及金融监管政策
          变动、或政府宏观货币政策变动、或国家政策对信贷额度进行管控或限制；
        </p>
        <p class="distance_50">
          4.1.8 授信人提出的其他条件。
        </p>
        <p class="distance_50">
          4.2
          尽管有前款所述，以上额度实际支用先决条件的设立并不代表授信人在上述条件满足时
          必然有放款或提供银行信用的义务；并且，如授信人在上述条件未全部满足时即实际提
          供了贷款或银行信用的，也不构成授信人的履约瑕疵。
        </p>
        <p class="distance" style="color:#000;font-weight:bold; text-align:center ">
          第五条 支用额度的清偿
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          5.1
          受信人应按授信人的要求及有关文件约定按时清偿因支用授信额度而形成的各种债务。
          并承诺其将于本合同或浦银快贷个人借款合同约定的每一债务到期日的早上零点以前，
          将应还债务金额足额存入浦银快贷个人借款合同约定的还款账户中。受信人在此不可撤
          销地授权授信人可从浦银快贷个人借款合同约定的还款账户中主动扣收到期应还债务
          金额。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          5.2
          若受信人与授信人约定的还款账户的存款余额不足以清偿受信人到期债务的或未明确
          约定还款账户的，受信人在此不可撤销地授权授信人有权从受信人开立于授信人及上海
          浦东发展银行各营业机构的任一账户及受信人及受信人为法定代表人或负责人的企业
          在上海浦东发展银行股份有限公司的支付账户或应收款项等中扣收任一到期未还的债
          务金额，包括但不限于本金、利息、罚息、违约金、手续费、代垫款项及其他相关费用。
        </p>
        <p class="distance_50">
          5.3
          若受信人授权授信人扣款的存款账户为可透支账户，则受信人在此不可撤销地进一步授
          权，当该账户中存款余额不足以归还应付债务时，授信人可以在账户允许透支金额范围
          内以透支方式扣收到期应还债务金额，由此发生的透支本金、利息和相关费用均由受信
          人承担。
        </p>
        <p class="distance_50">
          5.4 贷款的还款方式：
        </p>
        <p class="distance_50">
          5.4.1.
          依据本合同在线签署的浦银快贷个人借款合同项下贷款的归还采用浦银快贷
          个人借款合同所约定的方式。
        </p>
        <p class="distance_50">
          5.4.2.
          分期还款的受信人自贷款实际发放的次月（公历概念）约定还款日起开始还款。
          贷款实际发放后次月的首期还款贷款利息的计算方法具体为，如贷款实际发放
          日至次月约定还款日之间的贷款实际占用天数小于一期的，首期还款贷款利息
          根据贷款实际占用天数按照本合同 5.4.3 条计息方式确定；如贷款实际发放日
          至次月约定还款日之间的贷款实际占用天数大于一期的，首期还款贷款利息将
          分为一期的应还利息及超过一期部分的应还利息分别计算，其中：一期的应还
          利息按照约定还款方式计算利息，超过一期部分的应还利息根据贷款实际占用
          天数按照本合同 5.4.3 条计息方式确定；如贷款实际发放日至次月约定还款日
          之间的贷款实际占用天数等于一期的，首期还款贷款利息即按照约定还款方式
          计算的当期应还利息。
        </p>
        <p class="distance_50">
          5.4.3.
          前款提及的计息方式为：贷款利息采取对年、对月、对日的计算方法，如果不
          能对年、对月、对日，以月末最后一日为对日。贷款期限满年的按年利率计算，
          满月的按月利率计算，有整年（月）又有零头天数的，整年（月）部分按年（月）
          利率计算，仅零头天数按实际天数计算，其计算公式为：
          全是整年整月的：利息=本金×时期（年或月数）×年或月利率；
          有整年（月）又有零头天数的：利息=本金×[时期（年或月数）×年或月利
          率+零头天数×日利率]
        </p>

        <p class="distance_50">
          5.4.4.
          若发生贷款逾期，则该期未还贷款本息的逾期罚息，应在归还逾期贷款本息时
          一并缴付，且授信人有权对受信人未支付的利息计收复利。
        </p>
        <p class="distance_50">
          5.4.5.
          除采用固定利率的情形外，授信人因中国人民银行调整利率因素而对每期应付
          本息款额所作的调整，受信人须无条件照此履行。
        </p>
        <p class="distance_50">
          5.4.6.
          受信人提前归还贷款，应事先向授信人提出在线书面申请并征得授信人的同意。
          未取得授信人同意的，受信人仍应当依照有关文件约定的期限还本付息。
        </p>
        <p class="distance_50">
          5.4.7. 提前归还贷款的起点金额应符合双方确认同意的贷款文件的约定。
        </p>
        <p class="distance_50">
          5.4.8.
          受信人如提前归还部分贷款本息，对提前还款部分，在提前还款日当日及以前仍按有关约定计收贷款利息，不计退已计收的贷款利息。受信人如一次性提前
          归还全部结欠本金及利息的，授信人有权在提前还款日当日及以前仍按有关约
          定计收贷款利息，不计退已计收的贷款利息，不计收提前还款日之后的贷款利息。
        </p>
        <p class="distance_50">
          5.4.9.
          受信人如提前归还贷款本金的，授信人有权按照双方确认同意的贷款文件的约
          定向受信人收取违约金。
        </p>
        <p class="distance" style="color:#000;font-weight:bold; text-align:center">
          第六条 授信担保
        </p>
        <p class="distance_50">
          6.1
          受信人因支用本合同项下额度而形成的债务（包括本合同及/或浦银快贷个人借款合同
          项下的所有现时债务或或有负债）而向授信人提供的担保（如有）详见本合同第
          14.5 条的约定。
        </p>

        <p class="distance" style="color:#000;font-weight:bold; text-align:center">
          第七条 担保财产的变更
        </p>
        <p class="distance_50">
          7.1
          本合同项下担保财产（包括质押财产、抵押财产）如需变更的，应事先经授信人书面同
          意。
        </p>
        <p class="distance_50">
          7.2
          授信人有权按其认可的变更后的质押财产、抵押财产的价值调整本合同项下的授信额度
          金额。
        </p>
        <p class="distance_50">
          7.3
          授信人同意变更质押财产、抵押财产的，受信人、授信人双方应签订个人授信合同的补
          充协议或补充合同，并签订新的最高额抵押、最高额质押合同。
        </p>
        <p class="distance_50">
          7.4 受信人只能在变更后的授信额度金额内办理授信额度新的支用。
        </p>

        <p class="distance" style="color:#000;font-weight:bold; text-align:center">
          第八条 保证与陈述
        </p>
        <p class="distance_50">
          8.1 本合同项下受信人向授信人陈述和保证如下：
        </p>
        <p class="distance_50">
          8.1.1
          受信人为独立的法律主体，具备所有必要的权利能力、能以自身名义履行本合
          同的义务并独立承担民事责任。在线签署本合同是受信人的真实意思表示，对
          其具有法律约束力。
        </p>
        <p class="distance_50">
          8.1.2
          受信人确认，受信人已授权百望股份有限公司将其在百望股份有限公司平台上的个人信息及经营数据提供给授信人，并授权授信人通过百望股份有限公司将
          授信审核相关信息反馈给受信人。受信人承诺将根据授信人不时提出的要求及
          时提供相关资料，并保证其所出具的涉及本合同及有关浦银快贷个人借款合同
          的所有文件和资料以及在线申请过程中填录的信息均为真实、有效、完整、准
          确而无任何隐瞒的。
        </p>
        <p class="distance_50">
          8.1.3
          受信人在此保证其签署和履行本合同的行为并不违反其所应遵守的法律、法规、
          规章、判决、裁决及命令，也不与其签署的任何合同、协议或承担的任何其他
          义务相抵触。
        </p>
        <p class="distance_50">
          8.1.4
          受信人确认，在本合同在线签署时没有隐瞒已经发生或将要发生的任何影响或
          可能影响其签署或履行本合同、或可能对其财务状况产生重大不利影响的诉讼
          案件、仲裁案件、行政程序、财产保全措施、强制执行程序或其他可能对个人
          或家庭经济状况产生重大不利影响的事件；并且，受信人将在本合同履行期内
          继续向授信人承担上述信息的及时披露义务。在发生前述事件时，受信人应当
          在有关事件发生之日或其知悉之日后的 5 个工作日内通知授信人。
        </p>

        <p class="distance_50">
          8.1.5
          受信人的工作、住所（或联系住址）、联系电话等信息发生变更的，受信人应在
          该变更发生后的 5 个工作日内通知授信人；
        </p>
        <p class="distance_50">
          8.1.6
          受信人保证其签署、履行本合同所需的所有手续均已合法办理完毕并有效。
        </p>
        <p class="distance_50">
          8.1.7
          受信人保证其对于授信资金的使用，将符合有关法律的规定及本合同的约定，
          并且其自愿接受授信人对资金使用情况随时进行检查。
        </p>
        <p class="distance_50">
          8.1.8
          受信人保证按照本合同及有关浦银快贷个人借款合同约定的还款方式及还款计
          划按期清偿所支用额度。
        </p>
        <p class="distance_50">
          8.1.9
          受信人保证在本合同有效期间，将根据授信人不时提出的要求，提供、增加或
          变更授信人满意的担保措施。如授信人要求，受信人还同意办理由授信人指定
          险种、保险金额及保险期限，并以授信人为被保险人或保险赔偿之第一受益人
          的相关保险。有关保险单正本及抵（质）押物所有权凭证及抵押权利凭证或证
          明正本应存放于授信人处。
        </p>
        <p class="distance_50">
          8.1.10
          在本合同有效期内受信人为他人债务提供担保的（无论是否支用本合同额度），
          应提前书面通知授信人并征得授信人同意。
        </p>
        <p class="distance_50">
          8.1.11
          受信人确认，授信人依法将本合同项下的债权转让给第三人时无须征得受信人
          及担保人的同意，受信人应继续履行本合同项下的还款义务，担保人（如有）应继续按本合同约定承担担保责任。
        </p>
        <p class="distance_50">
          8.1.12
          受信人确认，其将配合授信人按照国家法律法规及监管规定对其开展的反洗钱
          尽职调查活动。受信人同意，若其频繁涉嫌洗钱的，授信人有权终止本协议。
        </p>
        <p class="distance" style="color:#000;font-weight:bold; text-align:center">
          第九条 授信额度的重设、调整和变更
        </p>
        <p class="distance_50">
          9.1
          若受信人支用授信额度的申请日与授信额度初始审核设定日或最近一次授信额度重新
          审核设定日之间间隔超过 1
          年以上，授信人有权对授信额度进行重新核定。重新核定
          内容应包括但不限于对受信人提供的各类担保方式及受信人信用状况的评估等。受信人
          应当按授信人要求在授信人重新审核设定时配合授信人完成授信额度的重新设定。
        </p>
        <p class="distance_50">
          9.2
          授信人有权在重新设定授信额度时自行重新评估有关抵（质）押物的价值并将其作为额
          度调整的依据。
        </p>
        <p class="distance_50">
          9.3
          受信人未在授信人重新审核设定授信额度时配合授信人完成对授信额度重新设定的，授
          信人有权自重新审核设定时起暂时冻结受信人对授信额度的使用直至完成对受信人进
          行重新评估及额度的重新审核设定工作，或直接取消受信人尚未支用部分的授信额度。
        </p>
        <p class="distance_50">
          9.4
          在本合同履行过程中，授信人保留随时对授信额度进行调整和重新评定的权利；在发生
          以下情形时，授信人有权单方暂停受信人的额度支用并有权对授信额度金额进行调整或
          取消，该额度调整或取消(收回)在授信人通过短信、百望股份有限公司平台在线通知等
          方式到达受信人时立即生效：
        </p>
        <p class="distance_50">
          9.4.1 国家的金融政策、货币政策、信贷政策发生重大调整；
        </p>
        <p class="distance_50">
          9.4.2 授信人的信贷政策发生重大调整；
        </p>
        <p class="distance_50">
          9.4.3 受信人所在地区发生或潜伏重大金融风险；
        </p>
        <p class="distance_50">
          9.4.4 受信人发生重大经营困难和风险；
        </p>
        <p class="distance_50">
          9.4.5 受信人所在行业或所经营商品或提供服务的市场发生重大变化；
        </p>
        <p class="distance_50">
          9.4.6
          受信人还款信用下降，融资风险增加，不再符合授信人授信额度管理要求；
        </p>
        <p class="distance_50">
          9.4.7
          受信人或其担保人违反本合同或有关浦银快贷个人借款合同，经授信人指出仍
          未改正；或取消担保；或担保财产的全部或部分灭失、毁损、没收、征用、依
          法扣押、查封、强制收购或执行，或价值减少且未获及时补救等，足以影响其
          担保能力的；
        </p>
        <p class="distance_50">
          9.4.8
          授信额度有效期内因利（汇）率变动等各种因素导致抵（质）押物价值发生重
          大变化的；
        </p>
        <p class="distance_50">
          9.4.9 受信人未按本合同第八条的约定履行承诺；
        </p>
        <p class="distance_50">
          9.4.10 出现本合同第十一条所列违约事件之一的；
        </p>
        <p class="distance_50">
          9.4.11 其他应改变授信额度的情况。
        </p>
        <p class="distance" style="color:#000;font-weight:bold; text-align:center">
          第十条 费用
        </p>
        <p class="distance_50">
          10.1
          受信人应根据法律法规规定及本合同约定承担本合同项下的相关费用和税费。
        </p>
        <p class="distance_50">
          10.2
          受信人在本合同有效期内，不能依照本合同或有关浦银快贷个人借款合同等业务文件约
          定履行还本付息及其他有关责任义务，致使授信人决定通过其他途径采取补救或追索措
          施的，由此引起的包括但不限于诉讼费、律师费、委托外部第三方公司催收费用等在内
          的一切费用概由受信人承担。
        </p>

        <p class="distance" style="color:#000;font-weight:bold; text-align:center">
          第十一条 违约事件
        </p>
        <p class="distance_50">
          11.1 下列任一事件，均构成受信人在本合同项下的违约：
        </p>
        <p class="distance_50">
          11.1.1
          受信人未按本合同或有关浦银快贷个人借款合同约定的用途使用额度或资金；
        </p>
        <p class="distance_50">
          11.1.2
          受信人未按本合同或有关浦银快贷个人借款合同约定按时足额偿还任意一期
          贷款本息或相关费用；
        </p>
        <p class="distance_50">
          11.1.3
          受信人以本合同项下授信额度所担保的贷款未按时偿还任意一期贷款本息或
          相关费用的；
        </p>
        <p class="distance_50">
          11.1.4
          受信人向授信人提供或通过百望股份有限公司向授信人提供虚假或者隐瞒重
          要事实的资料或信息；
        </p>
        <p class="distance_50">
          11.1.5
          受信人拒绝或阻碍授信人监督检查额度或贷款使用情况、保证人资信状况或担
          保财产状况的；
        </p>
        <p class="distance_50">
          11.1.6 受信人违反所在国法律法规，受到刑事处罚的；
        </p>
        <p class="distance_50">
          11.1.7
          受信人提供的担保人/担保财产已经或将要不再具有提供与贷款或有关债务相
          应的担保能力；或违反其签署的担保文件的；或担保财产的全部或部分灭失、
          毁损、没收、征用、依法扣押、查封、强制收购或执行；或由于担保人的其他
          行为，如担保人出国未征得授信人同意等导致其丧失担保能力；或担保能力或
          担保财产价值明显下降且没有重新落实授信人认可的相应担保的；
        </p>
        <p class="distance_50">
          11.1.8
          未经授信人同意，受信人或有关担保人将设定抵押权或质押权财产或权益拆迁、
          出售、转让、赠与或重复抵押的；
        </p>
        <p class="distance_50">
          11.1.9
          受信人或有关担保人与其他法人或经济组织、自然人签订有损授信人权益的合
          同、协议的；
        </p>
        <p class="distance_50">
          11.1.10
          受信人或有关担保人（或其法定代表人、董事、监事或高级管理人员）涉及或
          即将涉及诉讼，或被法院及其他权利机关监管、冻结其财产的；
        </p>
        <p class="distance_50">
          11.1.11
          受信人在还款期限内死亡、失踪或丧失民事行为能力后无继承人、受遗赠人、
          财产监（代）管人或监护人，或其继承人、受遗赠人、财产监（代）管人或监
          护人拒绝履行本合同的；
        </p>
        <p class="distance_50">
          11.1.12
          受信人转移个人资产，逃避债务以及出现其他损害授信人权益的行为的；
        </p>
        <p class="distance_50">
          11.1.13
          受信人家庭财务状态出现重大问题，或所经营的企业财务状况恶化，经营出现
          严重困难，或发生对其正常经营、财务状况或偿债能力产生不利影响的事件或
          情况的；
        </p>
        <p class="distance_50">
          11.1.14
          受信人未遵守本合同有关保证与陈述条款或发生其他违反本合同条款情形的；
        </p>
        <p class="distance_50">
          11.1.15 本合同有关担保人发生担保文件项下违约的；
        </p>
        <p class="distance_50">
          11.1.16 受信人未履行其对授信人其他到期债务的；
        </p>
        <p class="distance_50">
          11.1.17 授信人认为足以影响受信人债务清偿能力的其他情形。
        </p>
        <p class="distance" style="color:#000;font-weight:bold; text-align:center">
          第十二条 违约处理
        </p>
        <p class="distance_50">
          12.1
          当本合同第十一条所列违约事件之一项或数项出现时，授信人可酌情采取下列一种或数
          种措施进行处理：
        </p>
        <p class="distance_50">
          12.1.1 限期纠正违约行为；
        </p>
        <p class="distance_50">
          12.1.2 调整授信额度金额或有效期；
        </p>
        <p class="distance_50">
          12.1.3 暂停使用、取消（收回）或冻结授信额度；
        </p>
        <p class="distance_50">
          12.1.4
          按中国人民银行有关规定及浦银快贷个人借款合同的约定计收罚息及复利；
        </p>
        <p class="distance_50">
          12.1.5 有权上浮贷款执行利率并立即执行；
        </p>
        <p class="distance_50">
          12.1.6 要求受信人另行提供经授信人认可的保证、抵押、质押或其他担保；
        </p>
        <p class="distance_50">
          12.1.7
          宣布本合同提前到期（此时本合同及全部浦银快贷个人借款合同项下所有债务也均提前到期）；
        </p>
        <p class="distance_50">
          12.1.8
          宣布本合同及有关浦银快贷个人借款合同项下的债务（包括贷款本息、费用或
          其他应付金额）立即部分或全部提前到期，并要求受信人立即归还；
        </p>
        <p class="distance_50">
          12.1.9
          主动从受信人开立在上海浦东发展银行各营业机构的任一账户（包括可透支账
          户） 及受信人及受信人为法定代表人或负责人的企业在百望股份有限公司的支
          付账户或应收款项等 中划扣款项以清偿贷款本息、相关费用等所有债务；如拟
          扣划账户中的币种与债务币种不一致的，有权按授信人扣划当日所公布的汇率
          自行换算后扣划，相关风险和损失概由受信人承担；
        </p>
        <p class="distance_50">
          12.1.10
          按有关担保合同的约定处分抵押财产或质押财产以清偿债务，或依法追索保证
          人的连带责任；
        </p>
        <p class="distance_50">
          12.1.11 采取法律法规允许的其他必要措施。
        </p>
        <p class="distance" style="color:#000;font-weight:bold; text-align:center">
          第十三条 其他条款
        </p>
        <p class="distance_50">
          13.1
          除非本合同另有相反约定，受信人与授信人原签有授信合同的，自本合同生效之日起，
          原授信合同项下叙做的具体业务尚有未清偿余额的，自动纳入本合同项下，并直接占用
          本合同项下授信额度。受信人应取得原授信合同项下担保人对于本合同的确认。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          13.2
          受信人担保人（如有）同意并授权：授信人有权将在受信人与授信人在本合同项下授信
          业务关系建立和存续期间获得的与受信人及担保人有关的信息，包括信贷信息、信用信
          息、个人基本信息、不良信息、本合同履约信息、违约信息和其他信息资料，提供给金
          融信用信息基础数据库及其他经中国人民银行批准设立的征信机构的数据库，以及本合
          同 14.1
          条约定的第三方信息平台；同时，受信人及担保人亦授权授信人在上述期间有
          权向上述数据库查询受信人及担保人的全部信息及信用报告 。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          13.3
          受信人及担保人（如有）同意并授权：当受信人未按时偿还本合同项下贷款本息时，授
          信人有权为催收受信人欠款之目的将本合同项下有关的贷款情况信息提供给催收机构；
          受信人未按时偿还贷款本息连续三个月以上的（含三个月），授信人有权根据受信人的
          违约情况酌情决定向有关单位、新闻媒体等公开受信人的违约信息 。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          13.4
          授信人对受信人提供的个人金融信息资料予以保密，但授信人使用、向百望股份有限公
          司披露、根据法律法规规定及政府、监管部门的要求披露或本合同另有约定的情形除外。
        </p>
        <p class="distance_50">
          13.5 廉洁自律条款
          受信人在此确认，其已充分了解和知悉授信人反对其员工利用职务之便
          谋取任何形式利益之立场，并承诺将本着廉洁公平原则避免此类情形，不向授信人的员
          工私自提供任何形式的回扣、礼金、有价证券、贵重物品、各种奖励、私人费用补偿、
          私人旅游、高消费娱乐等不当利益。
        </p>
        <p class="distance_50">
          13.6
          本合同适用中华人民共和国法律（为本合同目的，不包括香港、澳门特别行政区及台湾
          地区的法律）。任何有关本合同的争议，均由授信人住所地或受信人住所地的人民法院
          管辖。本合同当事人另有约定的除外。
        </p>
        <p class="distance_50">
          13.7
          除另有约定，本合同各方在本合同填写的地址为各方同意的通讯或送达地址，任何书面
          通知只要发往该地址，均视为已送达；该地址如有变动，变动方应于变动发生之日起
          5
          个工作日内书面通知签约各方，否则对其他各方不生效（但授信人地址发生变动的，仅
          需于营业场所或通过其他途径进行公告）。
        </p>
        <p class="distance_50">
          13.8
          本合同自受信人在线确认同意即视为签署本合同并生效。本合同至本合同约定的授信额
          度有效期届满时终止，但前述终止并不影响授信人与受信人就已发生债务所享有的权利
          及/或应承担的义务。
        </p>
        <p class="distance_50">
          13.9
          授信人与受信人依据本合同在额度有效期内所形成有关债权债务关系的所有法律性文
          件（包括但不限于在线签署的个人信用信息查询和提供在线授权书、浦银快贷个人借款
          合同和电子贷款凭证等）均为本合同的组成部分，并构成一个完整的合同整体。
        </p>
        <p class="distance_50">
          13.10 本合同中部分条款无效或被撤销，不影响本合同中其他条款的效力。
        </p>
        <p class="distance_50">
          13.11 本合同未尽事宜需要补充的，双方可约定并记载于本合同第 14.6
          条中。也可以另行达 成书面补充协议，作为本合同的附件。
        </p>
        <p class="distance_50">
          13.12
          本合同附件是本合同不可分割的组成部分，与本合同正文具有同等的法律效力。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第十四条 合同要素条款
        </p>
        <p class="distance_50">
          14.1 本合同相关的第三方信息平台为： 百望股份有限公司
        </p>
        <p class="distance_50">
          14.2 本合同项下授信额度总额为 RMB ___________ （人民币 元）。
        </p>
        <p class="distance_50">
          14.3 本合同项下授信额度有效期为_____ ，即自_____ 年 ____ 月 _____ 日起至 ______ 年 _____  月 ______ 日止。
        </p>
        <p class="distance_50">
          14.4 本合同项下受信人支用授信额度的起点金额为（大写）____人民币_____ 元。
        </p>
        <p class="distance_50">
          14.5 受信人因支用本合同项下授信额度而形成的债务（包括本合同及/或浦银快贷（发票贷）个人借款合同项下的所有现时债务或或有负债），担保方式为信用。
        </p>
        <p class="distance_50">
        14.6 本合同附件包括：
        </p>
        <p class="distance_50">
        14.7 其他约定事项：
        </p>
        <p class="distance_50">
        （本页以下无正文）
        </p>

        <p class="distance" style="color:#000;font-weight:bold">
          受信人在此确认，在线签署本合同时对合同的全部条款均无疑义，并对当事人有关权利 义务和责任限制或免除条款的法律含义有准确无误的理解。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 6px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
